$(function () {
    if ($("#rd-section-envi1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-envi1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-envi1").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-envi2").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-envi2",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-envi2").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-envi3").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-envi3",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-envi3").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-envi4").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-envi4",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-envi4").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-envi5").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-envi5",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-envi5").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-envi6").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-envi6",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-envi6").addClass("ani_do").removeClass("op0");
            },
        });
    }
});
